import { render } from "./FaqList.vue?vue&type=template&id=2a9c55f0&scoped=true&ts=true"
import script from "./FaqList.vue?vue&type=script&lang=ts"
export * from "./FaqList.vue?vue&type=script&lang=ts"

import "./FaqList.vue?vue&type=style&index=0&id=2a9c55f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9c55f0"]])

export default __exports__